<template>
  <div class="page">
    <scanner
      ref="scanner"
      page-title="Контроль качества"
      title="VIN-номер"
      @input="checkVin"
    />

    <v-text-field
      v-model="comment"
      label="Комментарий"
      outlined
      hide-details="auto"
      :error="commentError"
      class="mt-4 px-4 comment"
    />
    <div style="color: red; margin-left: 20px; margin-bottom: 10px" v-if="commentError">Необходимо ввести комментарий</div>

    <app-loader v-if="loader" />

    <div v-else class="page__wrapper">
      <v-card
        v-for="it in cars"
        :id="it.vin"
        :key="it.vin"
        elevation="1"
        :color="getCardColor(it.vin)"
        class="mb-5"
        @click="setActive(it)"
      >
        <v-card-text>
          {{ it.vin }} <br>
          <span class="text-transform-none">{{ it.model }}, {{ it.color }}</span>
        </v-card-text>
      </v-card>
    </div>

    <div v-if="!isScannerShown" class="page__actions page__actions--home">
      <v-btn
        color="error lighten-1"
        x-large
        @click="$router.go(-1)"
      >
        Назад
      </v-btn>

      <v-btn
        class="mx-1"
        color="primary"
        x-large
        @click="$router.push('/navigation')"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>

      <v-btn
        v-if="result.vin && !loader"
        class="ml-auto"
        color="success"
        x-large
        @click="onSendClick"
      >
        Отправить
      </v-btn>
    </div>

    <result-modal
      v-model="resultModal"
      :title="resultModalTitle"
      :text="result.vin"
      success
    />

    <result-modal
      v-model="errorModal"
      :title="errorText"
    />

    <confirmation-modal
      v-model="confirmationModal"
      @submit="acceptVin"
    />
  </div>
</template>

<script>
import Scanner from '@/components/Scanner.vue';
import ConfirmationModal from '@/components/ConfirmationModal.vue';
import ResultModal from '@/components/ResultModal.vue';
import { mapState } from 'vuex';

export default {
  name: 'QualityAttention',
  components: {
    Scanner,
    ConfirmationModal,
    ResultModal,
  },
  props: {
    id: String,
    type: String,
  },
  data: () => ({
    loader: false,
    resultModal: false,
    confirmationModal: false,
    error: false,
    differentLocation: false,
    result: {},
    cars: [],
    errorModal: false,
    errorText: '',
    comment: '',
    commentError: false,
  }),
  computed: {
    ...mapState(['isScannerShown']),
    resultModalTitle() {
      const errorMessage = this.error?.response?.data?.Error?.message;

      if (errorMessage) return errorMessage;
      if (this.differentLocation) return 'В данной зоне автомобиль не обнаружен';
      return this.result.vin ? 'VIN найден' : 'Ошибка';
    },
  },
  watch: {
    resultModal(val) {
      if (!val) {
        this.stopScanning();
      }
    },
  },
  created() {
    this.getCarsByZone();
  },
  methods: {
    async getCarsByZone() {
      this.loader = true;
      try {
        const url = 'MobileOperatorInterface/QualityAttention/CarOnGateRelease';
        const { data } = await this.$http.get(url);
        const cars = await Promise.all(
          data.map((vin) => this.getCarInfo(vin)),
        );
        this.cars = cars;
      } catch (e) {
        this.onErrorHandler(e);
      } finally {
        this.loader = false;
      }
    },

    async getCarInfo(vin) {
      const { data } = await this.$http.get(
        `MobileOperatorInterface/BasicOperations/Car/${vin}`,
      );
      return data;
    },

    stopScanning() {
      this.$refs.scanner.stopScanning();
    },

    checkVin(vin) {
      this.differentLocation = false;
      this.error = false;
      this.result = {};

      this.$http
        .get(`MobileOperatorInterface/BasicOperations/Car/${vin}`)
        .then(({ data }) => {
          this.result = data;

          const inZone = this.cars.find((it) => it.vin === vin);

          if (!inZone) {
            this.differentLocation = true;
            this.result = {};
            this.resultModal = true;
            return;
          }

          const scrollTarget = document.getElementById(vin);
          if (scrollTarget) {
            this.$vuetify.goTo(scrollTarget, { offset: 300 });
          }

          this.resultModal = true;
        })
        .catch((e) => this.onErrorHandler(e));
    },

    onSendClick() {
      if (!this.comment) {
        this.commentError = true;
        return;
      }
      this.confirmationModal = true;
      this.commentError = false;
    },

    async acceptVin() {
      if (this.loader) return;

      this.loader = true;
      this.error = false;

      await this.$nextTick();

      const body = {
        vin: this.result.vin,
        comment: this.comment,
      };

      try {
        await this.$http.post(
          `MobileOperatorInterface/QualityAttention/Car/${this.result.vin}`,
          body,
        );

        this.result = {};
        this.comment = '';
        await this.getCarsByZone();
      } catch (e) {
        this.onErrorHandler(e);
      } finally {
        this.loader = false;
      }
    },

    getCardColor(vin) {
      return vin === this.result.vin ? 'success lighten-5' : 'yellow lighten-4';
    },

    setActive(car) {
      this.result = car;
    },

    onErrorHandler(e) {
      this.errorModal = true;
      this.errorText = e?.response?.data?.errorMess || 'Ошибка сервера';
    },
  },
};
</script>
